const p = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

const addCodes = (face,cB,current = []) => {
        var found = false;
        face.btns.forEach(btn => {
           if ( found ) return; 
           if ( btn.code ) return current.push(btn.code);
           var code = getCode();
           if ( current.indexOf(code) > -1 ) return found = true;
           current.push(btn.code = code);
           (btn.btns || []).forEach(btn => {
               if ( found ) return;
               if ( btn.code ) return current.push(btn.code);
               var code = getCode();
               if ( current.indexOf(code) > -1 ) return found = true;    
               current.push(btn.code = code);
               (btn.btns || []).forEach(btn => {
                    if ( found ) return;
                    if ( btn.code ) return current.push(btn.code);
                    var code = getCode();
                    if ( current.indexOf(code) > -1 ) return found = true;    
                    current.push(btn.code = code);                          
                })                          
           });
        });
        if ( found ) console.log('HIT !');
        if ( found ) return addCodes(face,cB,current);
        cB(face);
}

const getCode = () => {
    return new Array(5).fill(true).map(f => p[parseInt(Math.random(19) * 62)]).join('');
}

export default addCodes;